import { Box, ThemeOverride } from "@modernatx-internal/ui-kit-react";
import React from "react";

import { BlockProps } from "@/types/Block";

import { BlockColumns } from "./BlockColumns";
import { BannerNewsletterSignup } from "./blocks/BannerNewsletterSignup";
import { CollapseItems } from "./blocks/CollapseItems";
import { ExitModal } from "./blocks/ExitModal";
import { NoticeFilter } from "./blocks/NoticeFilter";
import { PageHeader } from "./blocks/PageHeader";
import { ProductHero } from "./blocks/ProductHero";
import { ProductsFooter } from "./blocks/ProductsFooter";
import { SoftGatingModal } from "./blocks/SoftGatingModal";
import { TableBlock } from "./blocks/Table";
import { TableUI } from "./blocks/TableUI";
import { BlockTransition } from "./BlockTransition";

const BlockComponent: React.FC<BlockProps> = (props) => {
  switch (props.component) {
    case "BannerNewsletterSignup":
      const { props: bannerNewsletterSignupProps } = props;
      return <BannerNewsletterSignup {...bannerNewsletterSignupProps} />;
    case "CollapseItems":
      const { props: collapseItemsProps } = props;
      return <CollapseItems {...collapseItemsProps} />;
    case "Columns":
      const { props: columnsProps } = props;
      return <BlockColumns {...columnsProps} />;
    case "PageHeader":
      const { props: pageHeader } = props;
      return <PageHeader {...pageHeader} />;
    case "ExitModal":
      const { props: exitModalProps } = props;
      return <ExitModal {...exitModalProps} />;
    case "ProductHero":
      const { props: productHeroProps } = props;
      return <ProductHero {...productHeroProps} />;
    case "ProductsFooter":
      const { props: productsFooterProps } = props;
      return <ProductsFooter {...productsFooterProps} />;
    case "SoftGateModal":
      const { props: softGateModalProps } = props;
      return <SoftGatingModal {...softGateModalProps} />;
    case "Table":
      const { props: tableProps } = props;
      return <TableBlock {...tableProps} />;
    case "TableUI":
      const { props: tableUIProps } = props;
      return <TableUI {...tableUIProps} />;
    case "Navigation":
      return null;
    case "NoticeFilter":
      const { props: noticeFilterProps } = props;
      return <NoticeFilter {...noticeFilterProps} />;
  }
};

export const Block: React.FC<BlockProps> = (props) => {
  const { block } = props;

  if (block?.transition) {
    return (
      <BlockTransition {...props}>
        <Box
          id={block?.id}
          sx={{
            boxShadow: block?.shadow,
            minHeight: block?.minHeight,
            pb: block?.spacingBottom,
            pt: block?.spacingTop
          }}
        >
          <BlockComponent {...props} />
        </Box>
      </BlockTransition>
    );
  }

  return (
    <ThemeOverride mode={block?.themeMode || "light"}>
      <Box
        id={block?.id}
        sx={{
          backgroundColor: block?.backgroundColor || "background01",
          backgroundImage: block?.backgroundImage,
          backgroundPosition: block?.backgroundPosition,
          backgroundRepeat: block?.backgroundRepeat,
          backgroundSize: block?.backgroundSize,
          boxShadow: block?.shadow,
          minHeight: block?.minHeight,
          pb: block?.spacingBottom,
          pt: block?.spacingTop,
          height: block?.height,
          flexDirection: block?.flexDirection,
          display: block?.display,
          flexGrow: block?.flexGrow
        }}
      >
        <BlockComponent {...props} />
      </Box>
    </ThemeOverride>
  );
};
